import React, {useState, useEffect} from 'react';
import {useMenu} from '../../../hooks/useMenu';
import SaveConfiguration from '../../Configuration/guided-setup/save-config';
import styles from './progressbar.module.css';

const ProgressBar = ({content, onExit}) => {
  const [completed, setCompleted] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCompleted(oldValue => {
        const newValue = oldValue + 10;

        if (newValue === 100) {
          clearInterval(interval);
          onExit();
        }
        return newValue;
      });
    }, 500);
  }, []);

  const fillerStyles = {
    height: '100%',
    width: `${completed}%`,
    backgroundColor: 'rgb(64, 64, 80)',
    borderRadius: 'inherit',
  };

  return (
    <>
      <div className={styles.caption}>
        <span>{content}</span>
      </div>
      <div className={styles.content}>
        <div className={styles.containerStyles}>
          <div style={fillerStyles}></div>
          <div className={styles.labelStyles}>{`${completed}%`}</div>
        </div>
      </div>
    </>
  );
};

export default ProgressBar;
